/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Badge_AwaitingInputs */

const vi_einvoice_badge_awaiting = /** @type {(inputs: Einvoice_Badge_AwaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chờ tạo hóa đơn`)
};

/**

* @param {Einvoice_Badge_AwaitingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_badge_awaiting = /** @type {((inputs?: Einvoice_Badge_AwaitingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Badge_AwaitingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_badge_awaiting(inputs)
});